<form *ngIf="kycForm" [formGroup]="kycForm" class="flex flex-col max-w-sm mx-auto">
	<div *ngIf="(isSoleTrader$ | async) === false" class="flex flex-col bg-white">
		<h2 class="text-xl mb-common" translate="kyc.ubo-list.title"></h2>
		<div class="mb-common" translate="kyc.ubo-list.pre"></div>
		<app-ubo-list [ubosLoading]="ubosLoading" [ubos]="ubos" (onAddClick)="addUBOModalVisible = true" (onRemoveClick)="deleteUBO($event)"></app-ubo-list>
	</div>
	<ng-content></ng-content>
	<div class="flex flex-col bg-white py-common">
		<h1 class="text-xl mb-common" translate="kyc.pep.title"></h1>
		<p class="mb-common" translate="kyc.pep.pre"></p>
		<div class="flex gap-4 lg:flex-col mb-common">
			<app-radio-item [value]="true" class="w-full" formControlName="isAnyOwnerPEP" [selectedBlackBorder]="true" [text]="'pep.yes' | translate" />
			<app-radio-item [value]="false" class="w-full" formControlName="isAnyOwnerPEP" [selectedBlackBorder]="true"  [text]="'pep.no' | translate " />
		</div>
		<div *ngIf="isAnyOwnerPEP.value" [@openClose]>
			<h2 *ngIf="(isSoleTrader$ | async) === false" class="text-base my-common" translate="kyc.pep.owners.title"></h2>
			<app-notification *ngIf="(ubos.dirty || ubos.touched) && ubos.errors?.atLeastOnePEP" type="error">
				{{
				'kyc.ubo.errors.at-least-one.pep' | translate }}
			</app-notification>
			<ng-container formArrayName="ubos" *ngFor="let ubo of ubos.controls; let i = index">
				<div [formGroupName]="i">
					<app-checkbox *ngIf="(isSoleTrader$ | async) === false" formControlName="is_pep" type="list" [collapsible]="true">
						<span text>{{ ubo.value.first_name + ' ' + ubo.value.last_name }}</span>
					</app-checkbox>
					<div *ngIf="ubo.value.is_pep" class="flex flex-wrap max-w-sm" body>
						<div class="w-full">
							<app-select
								[label]="'kyc.pep.owner.pep-how' | translate"
								[placeholder]="'select.placeholder' | translate"
								[options]="PEPTypeOptions"
								name="pep_type"
								formControlName="pep_type"></app-select>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>

	<div class="flex flex-col bg-white py-common">
		<h1 class="text-xl mb-common" translate="kyc.hrc.title"></h1>
		<p class="mb-common" translate="kyc.countries.pre"></p>
		<app-country-selector></app-country-selector>
	</div>
	<div class="flex flex-col items-center w-full pt-6" *ngIf="showSaveButton">
		<app-button (action)="save()" [loading]="loading" class="mb-common">{{ 'kyc.save' | translate }}</app-button>
	</div>
</form>

<add-ubo-modal *ngIf="addUBOModalVisible" [visible]="addUBOModalVisible" (close)="addUBOModalVisible = false" (add)="addUBO($event)"></add-ubo-modal>
